import { render, staticRenderFns } from "./IconHome.vue?vue&type=template&id=15d44b82"
import script from "./IconHome.vue?vue&type=script&lang=ts"
export * from "./IconHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports